import { render, staticRenderFns } from "./NoAccount.vue?vue&type=template&id=725cec78&scoped=true&"
import script from "./NoAccount.vue?vue&type=script&lang=js&"
export * from "./NoAccount.vue?vue&type=script&lang=js&"
import style0 from "./NoAccount.vue?vue&type=style&index=0&id=725cec78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725cec78",
  null
  
)

export default component.exports